/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Thresholds that are never enforced. Every other group here is a hard rule the backend rejects a
 * quote request on; this only drives a soft "are you sure?" nudge beside the field the customer is
 * typing into, and a customer can ignore it and still book. They catch line items that pass every
 * hard limit while being physically impossible, whose bad numbers would otherwise flow straight
 * into the freight class and the price.
 * 
 * @export
 * @interface ShipmentLimitsAdvisory
 */
export interface ShipmentLimitsAdvisory {
    /**
     * Warn above this implied density (weight / volume). Solid steel is about 490 lb/ft3, so anything past this is a data-entry mistake rather than unusually dense freight.
     * @type {number}
     * @memberof ShipmentLimitsAdvisory
     */
    maxDensityPoundsPerCubicFoot: number;
}

/**
 * Check if a given object implements the ShipmentLimitsAdvisory interface.
 */
export function instanceOfShipmentLimitsAdvisory(value: object): value is ShipmentLimitsAdvisory {
    if (!('maxDensityPoundsPerCubicFoot' in value) || value['maxDensityPoundsPerCubicFoot'] === undefined) return false;
    return true;
}

export function ShipmentLimitsAdvisoryFromJSON(json: any): ShipmentLimitsAdvisory {
    return ShipmentLimitsAdvisoryFromJSONTyped(json, false);
}

export function ShipmentLimitsAdvisoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipmentLimitsAdvisory {
    if (json == null) {
        return json;
    }
    return {
        
        'maxDensityPoundsPerCubicFoot': json['maxDensityPoundsPerCubicFoot'],
    };
}

  export function ShipmentLimitsAdvisoryToJSON(json: any): ShipmentLimitsAdvisory {
      return ShipmentLimitsAdvisoryToJSONTyped(json, false);
  }

  export function ShipmentLimitsAdvisoryToJSONTyped(value?: ShipmentLimitsAdvisory | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'maxDensityPoundsPerCubicFoot': value['maxDensityPoundsPerCubicFoot'],
    };
}

